import { FeatureFlags } from '../../../common/model/config';

export const onyoAppFeatureFlags: FeatureFlags = {
  hideBackButton: false,
};
